/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const unregisterPushTokenResponseDataSchema = z.object({
  unregistered: z.boolean(),
});

export type IUnregisterPushTokenResponseData = z.infer<
  typeof unregisterPushTokenResponseDataSchema
>;

export const unregisterPushTokenResponseSchema = createApiResponseSchema(
  unregisterPushTokenResponseDataSchema,
) as z.ZodSchema<IAPI<IUnregisterPushTokenResponseData>>;

export type IUnregisterPushTokenResponse = IAPI<IUnregisterPushTokenResponseData>;
